import {SQC_GENERATE_STARTED, SQC_GENERATE_FINISHED, SQC_GENERATE_FAILED, SQC_DIALOG_TOGGLE} from 'constants/actionTypes';

export const sqcGenerateLoadStarted = (request, orderId) => ({type: SQC_GENERATE_STARTED, request, orderId});
export const sqcGenerateLoadFinished = (payload, orderId) => ({type: SQC_GENERATE_FINISHED, payload, orderId});
export const sqcGenerateLoadFailed = (payload, orderId) => ({type: SQC_GENERATE_FAILED, payload, orderId});
export const sqcDialogToggle = (sqcId, orderId) => ({type: SQC_DIALOG_TOGGLE, sqcId, orderId});



// WEBPACK FOOTER //
// ./src/actions/sqcActions.js